export const TERMS_URL = 'https://raceid.com/en/public/terms'
